import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  TikTokIcon,
  YoutubeIcon,
} from '@/components/ui/icons/icons-new'
import { cn } from '@/lib/utils'
import { type PublishablePlatformType } from '@backend/lib/db/schema/platform'

const PLATFORMS: {
  id: PublishablePlatformType
  label: string
  Icon: typeof InstagramIcon
  colors: string
}[] = [
  {
    id: 'linkedin',
    label: 'LinkedIn',
    Icon: LinkedinIcon,
    colors: 'bg-blue-500 hover:bg-blue-600',
  },
  {
    id: 'instagram',
    label: 'Instagram',
    Icon: InstagramIcon,
    colors: 'bg-pink-500 hover:bg-pink-600',
  },
  {
    id: 'facebook',
    label: 'Facebook',
    Icon: FacebookIcon,
    colors: 'bg-[#1877F2] hover:bg-[#0E61C7]',
  },
  { id: 'tiktok', label: 'TikTok', Icon: TikTokIcon, colors: 'bg-black hover:bg-gray-800' },
  { id: 'youtube', label: 'YouTube', Icon: YoutubeIcon, colors: 'bg-red-600 hover:bg-red-700' },
]

export function PlatformFilter({
  selected,
  onChange,
}: {
  /** Empty array = no filter (All highlighted). One or more = filter to those. */
  selected: PublishablePlatformType[]
  onChange: (next: PublishablePlatformType[]) => void
}) {
  const isAll = selected.length === 0

  const togglePlatform = (id: PublishablePlatformType) => {
    if (selected.includes(id)) {
      onChange(selected.filter((p) => p !== id))
    } else {
      onChange([...selected, id])
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-3">
      {PLATFORMS.map(({ id, label, Icon, colors }) => {
        // When `selected` is empty, every platform is included in the result
        // set, so render every icon as enabled. Once the user picks specific
        // platforms, the unpicked ones grey out — matches the workspace
        // header convention where colored = participating.
        const isIncluded = isAll || selected.includes(id)
        const hasRing = !isAll && selected.includes(id)
        return (
          <button
            key={id}
            aria-label={label}
            title={label}
            aria-pressed={selected.includes(id)}
            onClick={() => togglePlatform(id)}
            className={cn(
              'relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-white transition-all',
              isIncluded ? colors : 'bg-gray-400 opacity-50 hover:opacity-100',
              hasRing && 'ring-primary ring-offset-background ring-2 ring-offset-2',
            )}>
            <Icon width={18} height={18} color="#FFFFFF" />
          </button>
        )
      })}
    </div>
  )
}
